module.exports = {
      id: "icon-facebook-usage",
      viewBox: "0 0 13.521 25.459",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#icon-facebook",
      toString: function () {
        return this.url;
      }
    }